import { navigate } from '@/common/agents';
import { navigateWithTeamStudioCover } from '@/pages/--roboneo/team_studio/utils/teamStudioRouteCover';
import { isMyIpTeamStudioReturnHref } from './backNavigation';

/** 按来源完整路径返回；房间地址走 url 模式，避免 router pathname 丢掉 query 或打不中页面。 */
export function navigateToMyIpReturnHref(href: string): void {
  const options = { mode: 'url' as const, url: href, replace: true };
  if (isMyIpTeamStudioReturnHref(href)) {
    navigateWithTeamStudioCover(options);
    return;
  }
  navigate(options);
}
